import(/* webpackMode: "eager", webpackExports: ["NavigationSidebar"] */ "/app/src/shared/ui/navigation-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationTabMenu"] */ "/app/src/shared/ui/navigation-tab-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/src/shared/ui/sidebar.tsx");
